import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { toast , Bounce } from "react-toastify";

const SignupRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const signup_profile = Cookies.get("signup_profile");
  const user = Cookies.get("user") ? JSON.parse(Cookies.get("user")) : null;

  useEffect(() => {
    // Prevent infinite redirect loop by checking the current path
    if (signup_profile && user && location.pathname !== "/edit_profile") {
      toast.info("Please complete your profile first !", {
        position: "top-right",
        autoClose: 1200,
        theme: "dark",
        transition: Bounce,
        bodyClassName: "text-sm", // Applies font size only inside toast body

      });
      navigate("/edit_profile", { replace: true });
    }
  }, [signup_profile, user, location.pathname, navigate]);

  return null; // This component is only for handling redirection
};

export default SignupRedirect;
